module.exports = __webpack_public_path__ + "assets/img/sabc_videos_banner_leftarrow.webp?754fa1e74a9634bd4206c8fec22cd790";